"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getDowngradeValues: ()=>index_js_namespaceObject.getDowngradeValues,
    clientDowngrades: ()=>external_client_only_index_js_namespaceObject.clientDowngrades,
    clientDowngradeUtil: ()=>external_client_only_index_js_namespaceObject.clientDowngradeUtil,
    getForceCDNDowngradeRegion: ()=>index_js_namespaceObject.getForceCDNDowngradeRegion,
    getIsForceCDNDowngrade: ()=>index_js_namespaceObject.getIsForceCDNDowngrade,
    convertCDNRegion: ()=>index_js_namespaceObject.convertCDNRegion,
    getIsDisablePwaCache: ()=>index_js_namespaceObject.getIsDisablePwaCache,
    manualDowngradeKeys: ()=>index_js_namespaceObject.manualDowngradeKeys
});
const index_js_namespaceObject = require("./common/index.js");
const external_client_only_index_js_namespaceObject = require("./client-only/index.js");
exports.clientDowngradeUtil = __webpack_exports__.clientDowngradeUtil;
exports.clientDowngrades = __webpack_exports__.clientDowngrades;
exports.convertCDNRegion = __webpack_exports__.convertCDNRegion;
exports.getDowngradeValues = __webpack_exports__.getDowngradeValues;
exports.getForceCDNDowngradeRegion = __webpack_exports__.getForceCDNDowngradeRegion;
exports.getIsDisablePwaCache = __webpack_exports__.getIsDisablePwaCache;
exports.getIsForceCDNDowngrade = __webpack_exports__.getIsForceCDNDowngrade;
exports.manualDowngradeKeys = __webpack_exports__.manualDowngradeKeys;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "clientDowngradeUtil",
    "clientDowngrades",
    "convertCDNRegion",
    "getDowngradeValues",
    "getForceCDNDowngradeRegion",
    "getIsDisablePwaCache",
    "getIsForceCDNDowngrade",
    "manualDowngradeKeys"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
